import { combineReducers } from 'redux';

import slices from './slices';

export const reducers = {
  notifications: slices.notificationsSlice.reducer,
};

const reducer = combineReducers({
  notifications: reducers.notifications,
});

export default reducer;
